import { COLOR } from "../config.ts";

/** Lightweight pooled particle for hit bursts, graze sparks, ambient motes. */
export class Particle {
  x = 0;
  y = 0;
  px = 0;
  py = 0;
  vx = 0;
  vy = 0;
  life = 0;
  maxLife = 1;
  size = 4;
  drag = 0.9;
  color = COLOR.player;

  reset(
    x: number,
    y: number,
    vx: number,
    vy: number,
    life: number,
    size: number,
    color: number,
    drag = 0.9,
  ): void {
    this.x = this.px = x;
    this.y = this.py = y;
    this.vx = vx;
    this.vy = vy;
    this.life = this.maxLife = life;
    this.size = size;
    this.color = color;
    this.drag = drag;
  }
}
